import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { AreaFocus } from '../../../models';
import { Router } from '@angular/router';
import { PworkflowComponent } from '../index';
import { ServiceInterface } from 'services/service.interface';
import { GoogleAnalyticsEventsService } from 'services/google.analytics.events.service';
var SecondaryComponent = /** @class */ (function () {
    function SecondaryComponent(_services, _parent, router, googleAnalyticsEventsService) {
        this._services = _services;
        this._parent = _parent;
        this.router = router;
        this.googleAnalyticsEventsService = googleAnalyticsEventsService;
        //states: any[] = stateConstant;
        this.formClass = "";
        this.errormsg = new Array();
        this.errdisplay = false;
        this.trackingName = "Secondary";
        this.educationSelected = false;
        this.textOptional = "";
    }
    SecondaryComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, elmnt;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this._parent.campaignName) {
                            this.trackingName = this._parent.campaignName + " - Secondary";
                        }
                        if (this._parent.model.bucket_id == '10') {
                            this.educationSelected = true;
                        }
                        _a = this;
                        return [4 /*yield*/, this._services.getList('/secondarybucketlist/' + this._parent.model.bucket_id)];
                    case 1:
                        _a.secondaryBucketList = _b.sent();
                        if (this._parent.model.bucket_id == '10') {
                            this.educationSelected = true;
                            this.secondaryBucketList.map(function (x) {
                                if (x.secBucketId == 114 || x.secBucketId == 111 || x.secBucketId == 142 || x.secBucketId == 122) {
                                    x.order = 2;
                                }
                                else if (x.secBucketId == 131 || x.secBucketId == 151 || x.secBucketId == 149 || x.secBucketId == 126 || x.secBucketId == 36 || x.secBucketId == 35 || x.secBucketId == 118 || x.secBucketId == 123 || x.secBucketId == 140 || x.secBucketId == 81 || x.secBucketId == 145) {
                                    x.order = 1;
                                }
                                else if (x.secBucketId == 32 || x.secBucketId == 34 || x.secBucketId == 128 || x.secBucketId == 33 || x.secBucketId == 134) {
                                    x.order = 3;
                                }
                                else {
                                    x.order = 4;
                                }
                            });
                            this.secondaryBucketList.sort(function (a, b) {
                                if (a.order > b.order) {
                                    return 1;
                                }
                                else {
                                    return -1;
                                }
                            });
                            this.secondaryBucketList.sort(function (a, b) {
                                if (a.order == b.order) {
                                    if (a.secBucketTitle < b.secBucketTitle) {
                                        return -1;
                                    }
                                    if (a.secBucketTitle > b.secBucketTitle) {
                                        return 1;
                                    }
                                }
                            });
                        }
                        if (this._parent.model.bucket_id.includes("19")) {
                            this.textOptional = "";
                        }
                        else {
                            this.textOptional = "(Optional)";
                        }
                        elmnt = document.getElementById("top");
                        elmnt.scrollIntoView();
                        return [2 /*return*/];
                }
            });
        });
    };
    SecondaryComponent.prototype.getCheckboxValue = function (id) {
        if (this._parent.model.secondary_bucket.length > 0) {
            var index = this._parent.model.secondary_bucket.findIndex(function (x) { return x.id == id; });
            if (index > -1) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    SecondaryComponent.prototype.checkSecondaryBucket = function (event, id, name) {
        if (event.target.checked) {
            $(".secondary_bucket").removeClass('ng-checkinvalid');
            var csitem = new AreaFocus();
            if (this._parent.model.secondary_bucket.findIndex(function (x) { return x.id == id; }) < 0) {
                csitem.name = name;
                csitem.id = id;
                this._parent.model.secondary_bucket.push(csitem);
            }
        }
        else {
            for (var index = 0; index < this._parent.model.secondary_bucket.length; index++) {
                if (this._parent.model.secondary_bucket[index]["id"] == id) {
                    this._parent.model.secondary_bucket.splice(index, 1);
                }
            }
        }
    };
    SecondaryComponent.prototype.clickSubmit = function (valid) {
        this.errormsg = [];
        if (this._parent.model.bucket_id.includes("19") && this._parent.model.secondary_bucket.length < 1) {
            $(".secondary_bucket").addClass('ng-checkinvalid');
            valid = false;
        }
        if (valid) {
            this.secondarysubmit();
        }
        else {
            if (this._parent.model.secondary_bucket.length < 1) {
                this.errdisplay = true;
                this.errormsg.push("Please select Area of focus.");
                valid = false;
            }
            this.formClass = "validate";
        }
    };
    SecondaryComponent.prototype.secondarysubmit = function () {
        //this.googleAnalyticsEventsService.emitEvent(this.trackingName, this.trackingName, this.trackingName, 3);
        if (this._parent.model.secondary_bucket.length > 0) {
            this._parent.model.secondary_bucket_ids = this._parent.model.secondary_bucket.map(function (a) { return a.id; }).join(',');
            this._parent.index++;
        }
        else {
            this._parent.index++;
        }
    };
    SecondaryComponent.prototype.prevAction = function () {
        this._parent.index--;
        //this.router.navigate(['/']);
    };
    return SecondaryComponent;
}());
export { SecondaryComponent };



// WEBPACK FOOTER //
// ./src/app/components/pworkflow/secondary/secondary.component.ts.pre-build-optimizer.js